<template>
  <div>
    <v-toolbar>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="onMenuBuscar"
            :tabindex="tabindex"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Alt + B</span>
      </v-tooltip>
      <!-- <v-text-field
        :value="razonSocial"
        :loading="loading"
        readonly
        class="mx-4"
        flat
        hide-no-data
        hide-details
        solo-inverted
      ></v-text-field> -->
      <div>
        {{ razonSocial }}
      </div>
      <v-chip
        v-if="cerrada"
        color="error"
        text-color="white"
        class="ml-2"
        small
      >
        CUENTA CERRADA
      </v-chip>
      <!--
      <v-btn
        icon
        @click="onMenuUsuario"
      >
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
      -->
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'CuentasSelectedComponent',
  components: {
    //
  },
  props: {
    tabindex: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      loading: false,
      search: null,
    }
  },
  beforeMount () {
    // Agrega el event listener en el gancho beforeMount
    window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy () {
    // Remueve el event listener en el gancho beforeDestroy
    window.removeEventListener('keydown', this.handleKeyboard);
  },
  created () {
    //
  },
  computed: {
    ...mapGetters('Cuentas', ['selected', 'cerrada']),
    razonSocial () {
      return (this.selected && this.selected.documento && this.selected.razon_social) ?
        this.selected.razon_social + ' | ' + this.selected.documento : ''
    }
  },
  methods: {
    ...mapActions('Cuentas', ['onClearEdited', 'onClearSelected']),
    onMenuUsuario (event) {
      event.preventDefault()
      this.$router.push({ name: 'clientes-form' })
    },
    onMenuBuscar (event) {
      event.preventDefault()
      this.onClearEdited()
      this.onClearSelected()
      // alert('Elimina la cuenta seleccionada y deja disponible para busqueda nueva!')
    },
    handleKeyboard(event) {
      if(event.altKey && event.key == 'b') {
        this.onMenuBuscar(event)
      }
    },
  },
}
</script>
